import { Injectable } from '@angular/core';
import { AppCredential } from '../models/app-credential';
import { Observable, BehaviorSubject } from 'rxjs';
import { tap, shareReplay } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  credential$: BehaviorSubject<AppCredential>;

  constructor(
    private _http: HttpClient,
    private _router: Router
  ) {
    this.credential$ = new BehaviorSubject<AppCredential>(null);
    this.tryRestore();
  }

  login(credential: AppCredential): Observable<any> {

    const body = credential;

    return this._http.post<any>(`/api/app/getIntegrations`,
      body,
      {
      headers: {
          'authorization': `basic ${btoa(`${credential.keyId}:${credential.secret}`)}`,
          'Content-Type': 'application/json'
      }
    }).pipe(
      tap(() => {
        this.credential$.next(credential);
        sessionStorage.setItem('credential', JSON.stringify(credential))
      }),
      shareReplay(1),
    );
  }

  logout() {
    this.credential$.next(null);
    sessionStorage.removeItem('credential');
    this._router.navigate(['/']);
  }

  tryRestore() {
    let credential = sessionStorage.getItem('credential');
    if (credential) {
      this.credential$.next(JSON.parse(credential));
    }
  }
}
